import { useMediaQuery } from 'react-responsive'

export const useDesktop = () => useMediaQuery({ minWidth: 992 })

export const useTablet = () => useMediaQuery({ minWidth: 576, maxWidth: 991 })

export const useMobile = () => useMediaQuery({ maxWidth: 576 })

export const useLt1300NotSm = () => useMediaQuery({ minWidth: 768, maxWidth: 1299 })
